import {TranslationFunction} from "../../i18n/i18n";
import {CatalogFormatter} from "../../common/catalog/CatalogFormatter";
import {PersonDataOrigin} from "../../client/person/PersonApiClient";

export class PersonDataOriginFormatter {
    static formatDataOrigin(dataOrigin: PersonDataOrigin | null | undefined, t: TranslationFunction): string {
        return CatalogFormatter.formatCatalogValueByCode(dataOrigin, "personDataOrigin", t);
    }
}
